import axios from "axios";
import pageURL from "../utils/pageUrls";
import { refreshToken } from "./cordlynxServices/auth";
import { tryCatch } from "@thalesrc/js-utils";

const getLangCode = () => {
  const lang = localStorage.getItem("locale");
  return lang ? lang.toLocaleUpperCase() : "TR";
};
const customAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    // platformCode: "admin",
    // tenantId: JSON.parse(localStorage?.getItem("selectedFactory")) ? JSON.parse(localStorage?.getItem("selectedFactory"))?.label : 0,
    languageCode: getLangCode(),
    // "Content-Type": "application/json; charset=utf8",
    Accept: "application/json",
    // "Authorization": token && "Bearer " + token?.accessToken,
    "x-tenant": "test",
  },
  // //withCredentials: false,
  // timeout: 10000,
  // timeoutErrorMessage: "API erişim sağlanamıyor!",
});

// unauth token
const requestHandler = (request) => {
  const token = localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : null;
  const accessToken = localStorage.getItem("accessToken") ? JSON.parse(localStorage.getItem("accessToken")) : null;
  const currentUser = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;

  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`;
  } else if (token) {
    request.headers.Authorization = `Bearer ${token.accessToken}`;
  }

  // Dil ve kullanıcı bilgilerini her istekte güncel oku
  request.headers.languageCode = getLangCode();

  if (currentUser?.userId) {
    request.headers["x-account"] = currentUser.userId;
  }

  return request;
};

const responseHandler = (response, history) => {
  return response;
};

const errorHandler = (error) => {
  console.error("AXIOS ERROR:", error);
  if (error?.response?.status === 401) {
    const userData = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
    getNewToken(userData);
  } else if (error?.response?.status === 403) {
    window.location.href = `${process.env.REACT_APP_SITE_URL}${pageURL.home}`;
  }
  /*   else if (error?.response?.status === 500) {
    window.location.href = `${process.env.REACT_APP_SITE_URL}${pageURL.home}`;
  } */

  return Promise.reject(error.response.data);
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

const getNewToken = async (userData) => {
  if (userData) {
    const payload = {
      userId: userData.userId,
      refreshToken: userData.accessToken,
    };

    const [err, res] = await tryCatch(refreshToken(payload));
    if (res) {

      const token = { accessToken: res?.accessToken, refreshToken: res?.refreshToken };
      localStorage.setItem("token", JSON.stringify(token));
      const newUserData = {
        ...userData,
        accessToken: res?.accessToken,
        refreshToken: res?.refreshToken,
      };
      localStorage.setItem("user", JSON.stringify(newUserData));
      window.location.reload();
    }
    if (err) {
      localStorage.removeItem("token");
      localStorage.removeItem("selectedRoles");
      localStorage.removeItem("selectedFactory");
      localStorage.removeItem("user");
      localStorage.removeItem("locale");
      window.location.href = `${process.env.REACT_APP_SITE_URL}${pageURL.login}`;
    }
  } else {
    localStorage.removeItem("token");
    localStorage.removeItem("selectedRoles");
    localStorage.removeItem("selectedFactory");
    localStorage.removeItem("user");
    localStorage.removeItem("locale");
    window.location.href = `${process.env.REACT_APP_SITE_URL}${pageURL.login}`;
  }
};

export default customAxios;
